/**
 * Formats the booking type terminology based on the context.
 * The B2B portal uses different terminology than the main Ops portal.
 * 
 * Main Ops -> B2B
 * Instant -> Instant
 * Part Load -> Standard
 * Full Load -> Full Load
 */
export const getDisplayBookingType = (bookingType, isB2B = false) => {
  if (!bookingType) return '—';
  
  const lowerType = bookingType.toLowerCase();
  
  if (isB2B) {
    if (lowerType.includes('part load') || lowerType.includes('part_load')) {
      return 'Standard';
    }
  }
  
  // Format beautifully (e.g. part_load -> Part Load)
  return bookingType
    .replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
};
